export const CONCILIATION_ADJUSTMENT_CAUSES_LIST_KEY = 'CONCILIATION_ADJUSTMENT_CAUSES_LIST';
export const CONCILIATION_ADJUSTMENT_CAUSES_ONE_KEY = 'CONCILIATION_ADJUSTMENT_CAUSES_ONE_KEY';
